import { useGenericQuery } from '../../../core/api/reactQuery';
import { getCourseDetails } from '../../../core/queries/course';

import { useCoursesStore } from '../stores/courseStore';

function useFetchCourseDetails(slug: string) {
  const { setCourse } = useCoursesStore();
  const { data, isError, error, isSuccess, isLoading } = useGenericQuery(
    ['fetch-course-details', slug],
    () => getCourseDetails(slug),
    setCourse
  );

  return {
    data,
    isError,
    isLoading,
    error,
    isSuccess,
  };
}

export { useFetchCourseDetails };
